@if (editable) {
  @if (type == _TableCellType.string) {
    <p-treeTableCellEditor>
      <ng-template pTemplate="input">
        <input pInputText class="width100p" [(ngModel)]="value" (ngModelChange)="afterEdit()">
      </ng-template>
      <ng-template pTemplate="output">
        @if (showNull && value == null) {
          <span class="badge severity-error" (click)="buttonClick()">null</span>
        }
        {{value}}
      </ng-template>
    </p-treeTableCellEditor>
  }
  @if (type == _TableCellType.int) {
    <p-treeTableCellEditor>
      <ng-template pTemplate="input">
        <p-inputNumber class="width100p" [(ngModel)]="value" (ngModelChange)="afterEdit()"></p-inputNumber>
      </ng-template>
      <ng-template pTemplate="output">
        @if (showNull && value == null) {
          <span class="badge severity-error" (click)="buttonClick()">null</span>
        }
        {{value}}
      </ng-template>
    </p-treeTableCellEditor>
  }
  @if (type == _TableCellType.byteSize) {
    <p-treeTableCellEditor>
      <ng-template pTemplate="input">
        <p-inputNumber class="width100p" [(ngModel)]="value" (ngModelChange)="afterEdit()"></p-inputNumber>
      </ng-template>
      <ng-template pTemplate="output">
        @if (showNull && value == null) {
          <span class="badge severity-error" (click)="buttonClick()">null</span>
        }
        {{_Utils.toDurationStringAdvanced(value, 2, true)}}
      </ng-template>
    </p-treeTableCellEditor>
  }
  @if (type == _TableCellType.duration) {
    <p-treeTableCellEditor>
      <ng-template pTemplate="input">
        <p-inputNumber class="width100p" [(ngModel)]="value" (ngModelChange)="afterEdit()"></p-inputNumber>
      </ng-template>
      <ng-template pTemplate="output">
        @if (showNull && value == null) {
          <span class="badge severity-error" (click)="buttonClick()">null</span>
        }
        {{_Utils.toDurationStringAdvancedNanos(value, 2, true)}}
      </ng-template>
    </p-treeTableCellEditor>
  }
  @if (type == _TableCellType.durationNanos) {
    <p-treeTableCellEditor>
      <ng-template pTemplate="input">
        <p-inputNumber class="width100p" [(ngModel)]="value" (ngModelChange)="afterEdit()"></p-inputNumber>
      </ng-template>
      <ng-template pTemplate="output">
        @if (showNull && value == null) {
          <span class="badge severity-error" (click)="buttonClick()">null</span>
        }
        {{_Utils.toDurationString(value)}}
      </ng-template>
    </p-treeTableCellEditor>
  }
  @if (type == _TableCellType.bool) {
    <span class="badge mouse-pointer" [class.severity-success]="value" [class.severity-error]="!value" (click)="switchBool()">{{value ? "Ja" : "Nein"}}</span>
  }
  @if (type == _TableCellType.color) {
    <p-treeTableCellEditor>
      <ng-template pTemplate="input">
        <input pInputText [(ngModel)]="value">
      </ng-template>
      <ng-template pTemplate="output">
        @if (showNull && value == null) {
          <span class="badge severity-error" (click)="buttonClick()">null</span>
        }
        {{value}}
      </ng-template>
    </p-treeTableCellEditor>
    }@if (type == _TableCellType.dateTime) {
    <p-treeTableCellEditor>
      <ng-template pTemplate="input">
        <input pInputText [(ngModel)]="value" (ngModelChange)="afterEdit()">
      </ng-template>
      <ng-template pTemplate="output">
        @if (showNull && value == null) {
          <span class="badge severity-error" (click)="buttonClick()">null</span>
        }
        {{value}}
      </ng-template>
    </p-treeTableCellEditor>
  }
  @if (type == _TableCellType.date) {
    <p-treeTableCellEditor>
      <ng-template pTemplate="input">
        <input pInputText [(ngModel)]="value" (ngModelChange)="afterEdit()">
      </ng-template>
      <ng-template pTemplate="output">
        @if (showNull && value == null) {
          <span class="badge severity-error" (click)="buttonClick()">null</span>
        }
        {{value}}
      </ng-template>
    </p-treeTableCellEditor>
  }
  @if (type == _TableCellType.button) {
    <p-treeTableCellEditor>
      <ng-template pTemplate="input">
        <input pInputText [(ngModel)]="value">
      </ng-template>
      <ng-template pTemplate="output">
        @if (showNull && value == null) {
          <span class="badge severity-error" (click)="buttonClick()">null</span>
        }
        {{value}}
      </ng-template>
    </p-treeTableCellEditor>
  }
}
@if (!editable && value != null) {
  @if (type == _TableCellType.string) {
    <span>{{value}}</span>
  }
  @if (type == _TableCellType.int) {
    <span>{{value}}</span>
  }
  @if (type == _TableCellType.bool) {
    <span class="badge" [class.severity-success]="value" [class.severity-error]="!value">{{value ? "Ja" : "Nein"}}</span>
  }
  @if (type == _TableCellType.color) {
    <span class="badge" [style.background]="_Utils.toColorHexString(value)">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
  }
  @if (type == _TableCellType.date) {
    <span>{{value | date:'dd.MM.yyyy'}}</span>
  }
  @if (type == _TableCellType.dateTime) {
    <span>{{value | date:'dd.MM.yyyy HH:mm:ss'}}</span>
  }
  @if (type == _TableCellType.button) {
    <span>
      <button pButton type="button" [icon]="value" (click)="buttonClick()"></button>
    </span>
  }
}
